<template>
    <div>
        <label>{{label}}</label>
        <div style="width:600px;">
            <div v-for="(field, fieldIndex) in JSON.parse(value || '[]')" :key="fieldIndex" class="d-flex py-2">
                <eod-list-item-autocomplete style="width:400px;" class="grow" placeholder="Selecteer een item..." :listId="listId" :value="field.listItemId" @input="val => updateFieldProperty(fieldIndex, 'listItemId', val)"></eod-list-item-autocomplete>
                <eod-text-field type="number" placeholder="50" :value="field.value" @input="val => updateFieldProperty(fieldIndex, 'value', val)">
                    <template v-slot:append>
                        <div class="px-4">%</div>
                    </template>
                </eod-text-field>
                <eod-btn @click="deleteDistribution(fieldIndex)" color="error" x-small fab class="ml-2"><v-icon>mdi-trash-can-outline</v-icon></eod-btn>
            </div>
        </div>
        <eod-btn @click="addDistribution" class="mt-2" small><v-icon small left>mdi-plus</v-icon>Toevoegen</eod-btn>
    </div>
</template>
<script>
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue';

export default {
    name: 'eod-distribution-field',
    components: {
        eodListItemAutocomplete
    },
    props:{
        label: String,
        listId: String,
        value: Array
    },
    methods:{
        addDistribution(){
            const existing = JSON.parse(this.value || '[]');
            existing.push({
                listItemId: null,
                value: null
            });
            this.$emit('input', JSON.stringify(existing));
        },
        deleteDistribution(fieldIndex){
            const existing = JSON.parse(this.value || '[]');
            existing.splice(fieldIndex, 1);
            this.$emit('input', JSON.stringify(existing));
        },
        updateFieldProperty(fieldIndex, propertyName, val){
            const existing = JSON.parse(this.value || '[]');
            existing[fieldIndex][propertyName] = val;
            this.$emit('input', JSON.stringify(existing));
        }
    }
}
</script>